import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { studioSelectionProductTypeIds } from 'src/api/productTypes';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import isFeatureEnabled from 'src/store/app/selector/isFeatureEnabled';
import { Feature, MESSAGE_TYPE } from 'src/store/app/types';
import { Store } from 'src/store/index';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';
import isEmbroideryProduct from 'src/util/embroidery/isEmbroideryProduct';

const sendEditorFeaturesPostMessageOperation = () => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  const store = getState();

  sendPostMessage({
    type: MESSAGE_TYPE['editor.setEditorHostSettings'],
    data: {
      allowAddElements: isFeatureEnabled(store, Feature.allowAddElements),
      allowRemoveElements: isFeatureEnabled(store, Feature.allowRemoveElements),
      allowLockElements: isFeatureEnabled(store, Feature.allowElementLockControl),
      allowPersonalizationLock: false,
    },
  });

  const integrationLayer = useIntegrationLayer();
  const isStudioSelectionProduct = studioSelectionProductTypeIds.filter((id) => id !== 176).includes(integrationLayer.productTypeId);
  const hasEmbroidery = isEmbroideryProduct(integrationLayer.productUid || integrationLayer.internalUid);

  const plugins: Array<{ name: string; state: string; extra?: Record<string, any>; indexInTabs?: number }> = [];

  if (isStudioSelectionProduct) {
    plugins.push({
      name: 'app-image-filters',
      state: 'enabled',
      extra: { noLogo: true },
    });
  }

  if (hasEmbroidery) {
    plugins.push({ name: 'app-graphics', state: 'enabled', indexInTabs: 3 });
  }

  if (plugins.length > 0) {
    sendPostMessage({
      type: MESSAGE_TYPE['plugins.setPlugins'],
      data: plugins,
    });
  }
};

export default sendEditorFeaturesPostMessageOperation;
